import { render, staticRenderFns } from "./BandDescription.vue?vue&type=template&id=33cbf313&scoped=true"
import script from "./BandDescription.vue?vue&type=script&lang=js"
export * from "./BandDescription.vue?vue&type=script&lang=js"
import style0 from "./BandDescription.vue?vue&type=style&index=0&id=33cbf313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbf313",
  null
  
)

export default component.exports